import { ItiBaseEditor } from './../iti-base-editor';
import { Component, Model, Prop, Ref, Watch } from 'vue-property-decorator';
import Vue from 'vue';
import { ValidationProvider } from 'vee-validate';
import EventBusType, { EventBus } from '@/shared/services/event-bus';

@Component({
    components: {
        ValidationProvider,
    },
})
export default class ItiSelect extends ItiBaseEditor {
    @Prop() public items!: any[];
    @Model('value-select-change') public model!: string;

    public async changed(ev: any) {
        this.$emit('value-select-change', ev);
    }
}
